import { FormImagePdf } from './FormImagePdf'

export const FormImageFillablePdf = (props) => {
  return <FormImagePdf {...props} />
}
